import NetworkTest, { NetworkTestOptions } from "opentok-network-test-js";
import { OT } from "opentok-network-test-js/dist/NetworkTest/types/opentok";

const checkOpenTokConnectivity = async (
  {
    openTokClient,
    apiKey,
    sessionId,
    token,
  }: {
    openTokClient: OT.Client;
    apiKey: string;
    sessionId: string;
    token: string;
  },
  options?: NetworkTestOptions,
): Promise<boolean> => {
  const networkTest = new NetworkTest(
    openTokClient,
    {
      apiKey,
      sessionId,
      token,
    },
    options,
  );

  const { success } = await networkTest.testConnectivity();

  return success;
};

export default checkOpenTokConnectivity;
